import { Button } from "antd";
import { useNavigate, useSearchParams } from "react-router-dom";

export default function OrderSuccess() {
  const navigate = useNavigate();

  const [searchParams] = useSearchParams();

  const orderNo = searchParams.get("order");

  return (
    <div
      style={{
        minHeight: "70vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        textAlign: "center",
        padding: 20,
      }}
    >
      {/* Success Icon */}
      <div
        style={{
          fontSize: 60,
          marginBottom: 20,
        }}
      >
        🎉
      </div>

      {/* Heading */}
      <h1
        style={{
          color: "#16a34a",
          marginBottom: 10,
        }}
      >
        Order Successful!
      </h1>

      {/* Order Number */}
      <p
        style={{
          fontSize: 18,
          marginBottom: 30,
        }}
      >
        Your order number is: <strong>{orderNo}</strong>
      </p>

      {/* Buttons */}
      <div
        style={{
          display: "flex",
          gap: 15,
          flexWrap: "wrap",
          justifyContent: "center",
        }}
      >
        <Button
          type="primary"
          size="large"
          onClick={() => navigate("/my-orders")}
        >
          View Order Details
        </Button>

        <Button size="large" onClick={() => navigate("/product-list")}>
          Continue Shopping
        </Button>
      </div>
    </div>
  );
}
